import "./ViewportGuard.css";
import { IconExpand, IconRotateCcw } from "../Icon/Icon.jsx";

export function ViewportGuard({
  width,
  height,
  minWidth,
  minHeight,
  canRotateToFit,
  t = (key) => key
}) {
  return (
    <div class="viewport-guard" role="presentation">
      <div class="viewport-guard-card">
        <div class="viewport-guard-icon-wrap">
          {canRotateToFit ? (
            <IconRotateCcw className="viewport-guard-icon" />
          ) : (
            <IconExpand className="viewport-guard-icon" />
          )}
        </div>
        <p class="viewport-guard-title">
          {canRotateToFit
            ? t("messages.viewportGuard.rotateTitle")
            : t("messages.viewportGuard.resizeTitle")}
        </p>
        <p class="viewport-guard-copy">
          {canRotateToFit
            ? t("messages.viewportGuard.rotateBody")
            : t("messages.viewportGuard.resizeBody")}
        </p>
        <p class="viewport-guard-meta">
          {t("messages.viewportGuard.currentViewport")} <span class="viewport-guard-dimensions">{width} x {height}</span>
        </p>
        <p class="viewport-guard-meta">
          {t("messages.viewportGuard.minimumViewport")} <span class="viewport-guard-dimensions">{minWidth} x {minHeight}</span>
        </p>
      </div>
    </div>
  );
}
